import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PayeeApi, ServiceApi } from '../shared/sdk/services';
import { Payee, PayeeService, AccessToken, PayeeSubmission, Service, Tag, Group} from '../shared/sdk/models';
import { Router } from '@angular/router';
import { GlobalEventsManager } from '../events-manager.component'
import { SubmissionDetailService } from "../shared/app/services/";
import { CONSTANT } from '../shared/app/constants'
import { LoopBackConfig } from "../shared/sdk/lb.config";

@Component({
  selector: 'dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: [ '../+merchant_onboarding/application.css','dashboard.css']
})

export class DashboardComponent implements OnInit {
  CONSTANT = CONSTANT;
  // public user: CustomUser;
  name: string;
  submissions: Array<PayeeSubmission>;
  services: Array<Service>;
  groups: Array<Group>;
  tags: Array<Tag>;

  payee: Payee;
  updateBizAcc: boolean;
  isShowJompayInfo = false;
  marchantSubStatus = '';

  constructor(
    private userApi: PayeeApi,
    private serviceApi: ServiceApi,
    private router: Router,
    private eventsManager: GlobalEventsManager,
    private submissionDetailService: SubmissionDetailService
  ) { 
  }


  ngOnInit() {
    window.scrollTo(0, 0)
    this.userApi.getCurrent().subscribe(
      (user: Payee) => this.name = user.first_name,
      err => {
        console.log(err);
        this.eventsManager.logout(true);
        this.eventsManager.showPopUp("Your session has expired. Please login.");
        this.eventsManager.loaded(true);
      }
    );

    this.serviceApi.find({where: {'id': {gt: -1}}}).subscribe(
      res => {
        this.services = res.map(
          (elem) => {
            return <Service> elem;
          }
        );
        
        // this.userApi.getServices(this.userApi.getCurrentId(), {
        //   where: {
        //     "submission_id": {
        //       neq: null
        //     }
        //   },
        //   include:[
        //     {
        //       "relation": "submission",
        //       "scope":{
        //         "include":[{
        //           "relation":"submission_tags",
        //           "scope":{
        //             "order": 'updated_at DESC',
        //             "include":{
        //               "relation":"tag"
        //             }
        //           }
        //         },{
        //           "relation": "submission_subtags",
        //           "scope": {
        //             "include": "subtag"
        //           }
        //         },{
        //           "relation": "submission_subtags",
        //           "scope": {
        //             "include": "subtag"
        //           }
        //         }
        //         ]
        //       }
        //     },
        //     {
        //       "relation":"service",
        //       "scope":{
        //         "include":"service_group"
        //       }
        //     }
        //   ]
        // }).subscribe(
        //   res => {
        //     console.log("this.submissions");
        //     console.log(res);
        //     this.submissions = res.map(
        //       (elem) => {
        //         return <Service> elem;
        //       }
        //     );
        //   },
        //   err => console.log(err)
        // );



        this.userApi.findById(this.userApi.getCurrentId(), {
        // this.userApi.getServices(this.userApi.getCurrentId(), {
       
        include:[
          {
            "relation":"services",
            "scope":{
              "order": 'created_at DESC',
              "include":[{
                "relation": "submission",
                "scope":{
                  
                  "include":[{
                    "relation":"submission_tags",
                    "scope":{
                      "order": 'created_at DESC',
                      "include":{
                        "relation":"tag"
                      }
                    }
                  },{
                    "relation": "submission_subtags",
                    "scope": {
                      "where":{
                       "deleted_at": null
                      },
                      "order": 'created_at DESC',
                      "include": "subtag"
                    }
                  }
                  ]
                }
              },
              {
                "relation":"service",
                "scope":{
                  "include":"service_group"
                }
              }
              ],
              "where": {
                  "submission_id": {
                  "neq": null
                }
              }
            }
          },
          {
            "relation":"cmoWebChecklist"
          },
          {
            "relation":"details"
          }
        ]
        }).subscribe(
          res => {
            console.log("this.submissions res");
            console.log(res);
            
            
            let response = <any> res;
            this.payee = response;

            this.submissions = response.services.map(
              (elem,index) => {
                // console.log("index");
                // console.log(index);
                console.log("elem");
                console.log(elem);
                this.submissionDetailService.setTagMapping(elem.submission.id,elem.submission.submission_tags);
                this.submissionDetailService.setSubTagMapping(elem.submission.id,elem.submission.submission_subtags);
                return <Service> elem;
              }
            );

            console.log({submissions: this.submissions.length});

            if (this.submissions.length > 0 && this.payee.details.business_account_no == null) {
              this.updateBizAcc = true;
            }
            else
              this.updateBizAcc = false;

            // console.log(this.submissionDetailService.subtagExists(0,3));
          },
          err => console.log(err)
        );
      }
    );

    // Reload script.js
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/script.js';
    script.onload = () => {
        console.log('SCRIPT LOAD');
    };
    script.onerror = () => console.log('SCRIPT ERROR');
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  getServiceName(sub: PayeeService) {
    // console.log("getServiceName");
    // console.log(sub.service_id);
    let s = this.services.find(
      (service: Service) => {
        return service.id == sub.service_id;
      }
    );
    
    return s == undefined ? s : s.name;
  }

  getSubmissionTagName(sub: PayeeService) {
    console.log("submission tags to check status -- huber->" +JSON.stringify(sub.submission.submission_tags));
    // console.log(sub.submission.submission_tags);
    //return ((this.isMaybank2uPay(sub) && !this.hasForm(sub)) ? null : sub.submission.submission_tags[0].tag.name_displayed_merchant);
      // ?"Our account manager will contact you for further discussion on this service."
      this.marchantSubStatus = (this.isMaybank2uPay(sub) && !this.hasForm(sub)) ? null : sub.submission.submission_tags[0].tag.name_displayed_merchant;
      console.log('ram----->  status>' + this.marchantSubStatus);
      return this.marchantSubStatus;
  }

  getSubmissionTagUpdatedAt(sub: PayeeService) {
    // console.log(sub.submission.submission_tags);
    // console.log(sub.submission.submission_tags);
    let date = new Date(sub.submission.submission_tags[0].updated_at);
    // let now = new Date();

    // var diff = now.getTime() - date.getTime();

    // var msec = diff;
    // var hh = Math.floor(msec / 1000 / 60 / 60);
    // msec -= hh * 1000 * 60 * 60;
    // var mm = Math.floor(msec / 1000 / 60);
    // msec -= mm * 1000 * 60;
    // var ss = Math.floor(msec / 1000);
    // msec -= ss * 1000;
    // return date.

    return (date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear())
  }

  // getSubmissionSubTagName(sub: PayeeService) {
  //   // console.log(sub.submission.submission_tags);
  //   // console.log(sub.submission.submission_tags);
  //   return ((this.isCcEcommerce(sub) && this.hasForm(sub) && (sub.submission.submission_subtags.length > 0))
  //     // ?"Our account manager will contact you for further discussion on this service."
  //     ?sub.submission.submission_subtags[0].subtag.description
  //     :null);
  // }

  // getSubmissionSubTag(sub: PayeeService) {
  //   // console.log(sub.submission.submission_tags);
  //   // console.log(sub.submission.submission_tags);
  //   return ((this.isCcEcommerce(sub) && this.hasForm(sub) && (sub.submission.submission_subtags.length > 0))
  //     // ?"Our account manager will contact you for further discussion on this service."
  //     ?this.ccSubTag[sub.submission.submission_subtags[0].subtag.id - 1]
  //     :null);
  // }

  // getSubmissionSubTagDeletedAt(sub: PayeeService) {
  //   // console.log(sub.submission.submission_tags);
  //   // console.log(sub.submission.submission_tags);
  //   return ((this.isCcEcommerce(sub) && this.hasForm(sub) && (sub.submission.submission_subtags.length > 0))
  //     // ?"Our account manager will contact you for further discussion on this service."
  //     ?sub.submission.submission_subtags[0].deleted_at
  //     :null);
  // }

  getMessage(sub: PayeeService) {
    if (this.isMaybank2uPay(sub) && !this.hasForm(sub)) {
      return false;
    }
    else{
      return null;
    }

    
  }

  isMaybank2uPayGroup(sub: PayeeService){
    if (sub != null && sub.service) {
      return (sub.service.group == CONSTANT.GROUP_MAYBANK2UPAY)?true:false;
    }
     
  }


  isMaybank2uPay(sub: PayeeService){
     return (sub.service.id == CONSTANT.SERVICE_MAYBANK2UPAY)?true:false;
  }


  isCc(sub: PayeeService){
     return ((sub.service.service_group && sub.service.service_group.id == CONSTANT.GROUP_CREDITCARD)) ? true : false;
  }

  isCcEcommerce(sub: PayeeService){
     return (sub.service.id == CONSTANT.SERVICE_CREDITCARD_ECOMMERCE)?true:false;
  }

  isWebsiteChecklistSubmitted(payee: Payee){
    return (payee.cmoWebChecklist[0].is_submitted);
  }

  hasForm(sub: PayeeService){
    return (sub.service.has_form == true)?true:false;
  }

  viewApplication(sub: PayeeSubmission) {
    // this.eventsManager.showPopUp('Went to ' + service);
    this.eventsManager.loaded(false);
    this.router.navigate(['/form'],{queryParams:{view:true}});
  }

  viewWebsiteChecklist(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    this.eventsManager.loaded(false);
    console.log("service.submission_id")
    console.log(service.submission_id)
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/form/website-checklist']);
  }

  viewEcomCardsOfferLetter(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    
    this.router.navigate(['/form/offer-letter']);
  }

  viewPOSOfferLetter(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    
    this.router.navigate(['/pos-offer-letter']);
  }

  viewUatLiveDataCardsEcom(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/cards-uat-live']);
  }

  viewUatLiveDataOnlineBanking(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/payee-code']);
  }

  viewTechnicalRequirementOnlineBanking(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/payment-notification-tech-req']);
  }

  viewOnlineBankingOfferLetter(service: PayeeService) {
    // this.eventsManager.showPopUp('Went to ' + service);
    // console.log(sub);
    this.eventsManager.loaded(false);
    this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/m2upay-offer-letter']);
  }

  goToUpdateBizAcc(){
    this.eventsManager.loaded(false);
    // this.submissionDetailService.setCurrentSubmissionId(service.submission_id)
    this.router.navigate(['/update-business-account']);
  }

  goToServices() {
    this.router.navigate(['/chooseBusiness']);
  }

  toggleJompayInfo() {
    this.isShowJompayInfo = !this.isShowJompayInfo;
  }

}